import React, { useState, useRef, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { Button,} from 'antd';
import "./styles.css";
import ReactMarkdown from "react-markdown";
import { useTranslation } from "react-i18next";

const CustomerIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="50"
            height="50.000003814697266"
            viewBox="0 0 50 50.000003814697266"
        >
            <defs>
                <clipPath id="master_svg0_31_35016">
                    <rect x="0" y="0" width="50" height="50.000003814697266" rx="0" />
                </clipPath>
            </defs>
            <g clip-path="url(#master_svg0_31_35016)">
                <g>
                    <ellipse
                        cx="24.375"
                        cy="24.375"
                        rx="19.375"
                        ry="19.375"
                        fill="#FFFFFF"
                        fill-opacity="1"
                    />
                </g>
                <g>
                    <path
                        d="M25,0C38.8,0,50,11.2,50,25C50,38.8,38.8,50,25,50C11.2,50,0,38.8,0,25C0,11.2,11.2,0,25,0ZM10.0583,33.5407C13.7271,39.0173,19.2378,42.5,25.3993,42.5C31.5607,42.5,37.0715,39.0173,40.7402,33.5407C36.7212,29.793,31.328,27.5,25.3993,27.5C19.4705,27.5,14.0774,29.793,10.0583,33.5407ZM25,22.5C29.1423,22.5,32.5,19.1421,32.5,15C32.5,10.8579,29.1423,7.5,25,7.5C20.8577,7.5,17.5,10.8579,17.5,15C17.5,19.1421,20.8577,22.5,25,22.5Z"
                        fill="#919499"
                        fill-opacity="1"
                    />
                </g>
            </g>
        </svg>
    );
};
const AddIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="24"
            height="24"
            viewBox="0 0 24 24"
        >
            <defs>
                <clipPath id="master_svg0_31_23287">
                    <rect x="0" y="0" width="24" height="24" rx="0" />
                </clipPath>
            </defs>
            <g clip-path="url(#master_svg0_31_23287)">
                <g>
                    <path
                        d="M12,22C6.47715,22,2,17.5228,2,12C2,6.47715,6.47715,2,12,2C17.5228,2,22,6.47715,22,12C22,17.5228,17.5228,22,12,22ZM11,11L7,11L7,13L11,13L11,17L13,17L13,13L17,13L17,11L13,11L13,7L11,7L11,11Z"
                        fill="#FFFFFF"
                        fill-opacity="1"
                    />
                </g>
            </g>
        </svg>
    );
};

const SharePage = () => {
    const { t, i18n } = useTranslation();
    // 是否是移动端
    const [isMobile, setIsMobile] = useState(true);
    const [messageId, setMessageId] = useState(null); //当前分享的messageId
    const [shareAgentData, setShareAgentData] = useState([]); //当前分享的数据
    const [searchParams] = useSearchParams();


    useEffect(() => {
        let isMobile = /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        );
        setIsMobile(isMobile);

        const messageId = searchParams.get("messageId");
        if(messageId){
            setMessageId(messageId)
        }
    }, []);

    useEffect(()=>{
        if(messageId){
            queryShareDetail()
        }
    },[messageId]);

    const queryShareDetail=()=>{
        fetch("https://chinapedia-test.goclouds.cn/chat/query/" + messageId)
            .then((res) => res.json()) // 解析 JSON
            .then((data) => {
                console.log('--------data---------',data);
                setShareAgentData(data);

            })
            .catch((err) => console.error("请求失败:", err));
    }

    return (
        <>
            {isMobile?(
                <div className="phoneShareContainer">
                    <div className="shareTitle">
                        {t("app.title")}
                    </div>
                    <div className="shareDetailContent">
                        {shareAgentData?.map(itemData => {
                            if (itemData.user === "user") {
                                return (
                                    <div className="customerMessage" style={{marginBottom: '20px'}}>
                                        <div className="customerText" dir={itemData.language === 'ar'?'rtl':'ltr'}>{itemData?.content}</div>
                                        <CustomerIcon/>
                                    </div>
                                )
                            } else {
                                return (
                                    <div className="agentMessage">
                                        <div class="agentBg">Pedia</div>
                                        <div className="agentMessage_content" dir={itemData.language === 'ar'?'rtl':'ltr'}>
                                            <ReactMarkdown
                                                // components={{code: CodeBlock}}
                                                children={itemData?.content}
                                            />
                                        </div>
                                    </div>
                                )
                            }
                        })}
                    </div>
                    <div className="shareButton">
                        <Button type="primary" icon={<AddIcon/>}>Start Chat</Button>
                    </div>
                </div>
            ) : (
                <div class="pcShareContainer">
                    <div class="shareTitle">
                        {t("app.title")}
                    </div>
                    <div className="shareDetailContent">
                        {shareAgentData?.map(itemData => {
                            if (itemData.user === "user") {
                                return (
                                    <div className="customerMessage" style={{marginBottom: '20px'}}>
                                        <div className="customerText" dir={itemData.language === 'ar'?'rtl':'ltr'}>{itemData?.content}</div>
                                        <CustomerIcon/>
                                    </div>
                                )
                            } else {
                                return (
                                    <div className="agentMessage">
                                        <div class="agentBg">Pedia</div>
                                        <div className="agentMessage_content" dir={itemData.language === 'ar'?'rtl':'ltr'}>
                                            <ReactMarkdown
                                                // components={{code: CodeBlock}}
                                                children={itemData?.content}
                                            />
                                        </div>
                                    </div>
                                )
                            }
                        })}
                    </div>
                    <div className="shareButton">
                        <a href="https://chinapedia-test.goclouds.cn" target="_blank">
                            <Button type="primary" icon={<AddIcon/>}>Start Chat</Button>
                        </a>
                    </div>
                </div>
            )}
        </>
    );
};

export default SharePage;



